import { render, staticRenderFns } from "./ListRecent.vue?vue&type=template&id=5e4c8d66&scoped=true&"
import script from "./ListRecent.vue?vue&type=script&lang=js&"
export * from "./ListRecent.vue?vue&type=script&lang=js&"
import style0 from "./ListRecent.vue?vue&type=style&index=0&id=5e4c8d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c8d66",
  null
  
)

export default component.exports